function updateCartRewardsProgress(cartTotalCents) {
  const thresholds = [
    { min: 10000, discount: '$20 off' },
    { min: 25000, discount: '$50 off' },
    { min: 50000, discount: '$100 off' }
  ];

  const percent = Math.min((cartTotalCents / 50000) * 100, 100);

  document.querySelectorAll('.progress-wrapper').forEach(wrapper => {
    const progressFill = wrapper.querySelector('.progress-fill');
    const remainingEl = wrapper.querySelector('.remaining-amount');
    const upcomingEl = wrapper.querySelector('.upcoming-discount');
    const messageEl = wrapper.querySelector('.discount-message');

    if (progressFill) {
      progressFill.style.setProperty('width', percent + '%', 'important');
      progressFill.style.setProperty('display', 'block', 'important');
      progressFill.style.setProperty('visibility', 'visible', 'important');
    }

    const next = thresholds.find(t => cartTotalCents < t.min);
    const unlocked = thresholds.filter(t => cartTotalCents >= t.min).pop();

    if (unlocked) {
      // Show unlocked discount message
      if (messageEl) {
        messageEl.innerHTML = `Congratulations! You've unlocked a <strong>${unlocked.discount}</strong> discount!`;
      }

      // Still show upcoming tier info if more available
      if (next) {
        const diff = (next.min - cartTotalCents) / 100;
        if (remainingEl) remainingEl.textContent = `$${diff.toFixed(2)}`;
        if (upcomingEl) upcomingEl.textContent = next.discount;
      } else {
        if (remainingEl) remainingEl.textContent = '';
        if (upcomingEl) upcomingEl.textContent = '';
      }

    } else if (next) {
      // No discount unlocked yet, show progress toward first tier
      const diff = (next.min - cartTotalCents) / 100;
      if (remainingEl) remainingEl.textContent = `$${diff.toFixed(2)}`;
      if (upcomingEl) upcomingEl.textContent = next.discount;
      if (messageEl) messageEl.textContent = '';
    }

    wrapper.classList.remove('hidden-until-ready');
  });
}


function triggerCartRewardsProgressUpdatedEvent() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      updateCartRewardsProgress(cart.original_total_price);
    });
}

const boosterCartEvents = [
  'booster:cart:update',
  'booster:cart:clear',
  'booster:cart:upsell',
  'booster:cart:b*add',
  'booster:cart:b*modal',
  'booster:cart:b*upsell'
];

boosterCartEvents.forEach(function (eventName) {
  document.addEventListener(eventName, function () {
    setTimeout(() => {
      console.log(`Booster cart event triggered: ${eventName}`);
      triggerCartRewardsProgressUpdatedEvent();
    }, 150);
  });
});

document.addEventListener('DOMContentLoaded', triggerCartRewardsProgressUpdatedEvent);